import request, { METHODS } from "src/utils/api-base";

const supplierApis = {
  createSupplier: (payload: any) => {
    return request({
      route: "/app/suppliers",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  getSupplierList: (params: {
    page: number;
    limit: number;
    status?: "active" | "inactive";
  }) => {
    return request({
      route: "/app/suppliers",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  editSupplier: (payload: any) => {
    return request({
      route: `/app/suppliers/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },
};

export default supplierApis;
